import React from "react";

/** Horizontal scroll wrapper for data tables on small screens. */
const TableScroll = ({ children }) => (
  <div className="table-scroll">{children}</div>
);

export default TableScroll;
